export default __webpack_public_path__ + "twilio.c1763f7a.png";